import { usePolicyRepository } from '../repositories';

export function usePolicies(policyType?: string, page = 1, perPage = 50) {
  const repo = usePolicyRepository();
  return repo.useList({ policyType, page, perPage });
}

export function usePolicy(id: string | undefined) {
  const repo = usePolicyRepository();
  return repo.useGet(id);
}

export function useCreatePolicy() {
  const repo = usePolicyRepository();
  const { create, loading, error } = repo.useCreate();
  return {
    mutate: (input: any) => create(input),
    mutateAsync: (input: any) => create(input),
    isPending: loading,
    loading,
    error,
  };
}

export function useUpdatePolicy() {
  const repo = usePolicyRepository();
  const { update, loading, error } = repo.useUpdate();
  return {
    mutate: (vars: { id: string; input: any }) => update(vars.id, vars.input),
    mutateAsync: (vars: { id: string; input: any }) => update(vars.id, vars.input),
    isPending: loading,
    loading,
    error,
  };
}

export function useDeletePolicy() {
  const repo = usePolicyRepository();
  const result = repo.useDelete();
  return {
    mutate: (vars: { id: string }) => result.delete(vars.id),
    mutateAsync: (vars: { id: string }) => result.delete(vars.id),
    isPending: result.loading,
    loading: result.loading,
    error: result.error,
  };
}
